"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTreeNode = exports.addTreeNode = exports.listTreeData = void 0;
const abortable_fetch_1 = require("../../utils/abortable-fetch");
function listTreeData(url, params) {
    return (0, abortable_fetch_1.abortableFetch)(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    });
}
exports.listTreeData = listTreeData;
function addTreeNode(url, parentId, formData) {
    const body = {
        ...formData,
        name: formData.label,
        active: true,
    };
    if (parentId) {
        body.parent = {
            id: parentId,
        };
    }
    return (0, abortable_fetch_1.abortableFetch)(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
}
exports.addTreeNode = addTreeNode;
function updateTreeNode(url, parentId, formData) {
    return (0, abortable_fetch_1.abortableFetch)(url + '/' + formData.id + '/name', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: formData.label,
    });
}
exports.updateTreeNode = updateTreeNode;
//# sourceMappingURL=tree-api.js.map